import React from "react";
import { FaInstagram, FaFacebookF, FaPinterest } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 font-serif">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-44">
        {/* Column 1: Social Media */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Social Media</h3>
          <div className="flex space-x-4">
            <a href="https://www.instagram.com/atelier_jenny/" target="_blank" className="text-gray-600 hover:text-gray-900">
            <FaInstagram size={24} />
            </a>
            <a href="https://www.facebook.com/jennyatelier/"  target="_blank" className="text-gray-600 hover:text-gray-900">
            <FaFacebookF size={24} />
            </a>
            <a href="https://gr.pinterest.com/jennykaraeth/"  target="_blank" className="text-gray-600 hover:text-gray-900">
            <FaPinterest size={24} />
            </a>
          </div>
        </div>

        {/* Column 2: Χρησιμες Πληροφοριες */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Χρησιμες Πληροφοριες</h3>
          <ul className="space-y-2">
            <li>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                FAQs
              </a>
            </li>
            {/* <li>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                RGPD
              </a>
            </li>
            <li>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                CGV
              </a>
            </li>
            <li>
              <a href="#" className="text-gray-600 hover:text-gray-900">
                Sitemap
              </a>
            </li> */}
          </ul>
        </div>

        {/* Column 3: Atelier */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Atelier</h3>
          <address className="text-gray-600 space-y-2 not-italic">
            <p>Μάρκου Μπότσαρη και Φιλίππου γωνία</p>
            <p>57400, Σίνδος, Θεσσαλονίκη</p>
            <p>Τηλ: 2310796819 - 6972204383</p>
            <p>Email: <a href="mailto:atelierjenny.bridal@gmail.com" className="hover:text-gray-900">atelierjenny.bridal@gmail.com</a></p>
          </address>
        </div>
      </div>

      {/* Horizontal Divider */}
      <div className="border-t border-gray-200 mt-8"></div>

      {/* Footer Bottom */}
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between text-gray-500 text-sm">
        <p>© Atelier Jenny 2024</p>
        <p>All Rights Reserved </p>
      </div>
    </footer>
  );
};

export default Footer;
